<template>
  <div class="all" v-loading="loading" element-loading-text="加载中,请稍后...">
    <div class="header">
      <div class="flex">
        <div class="base-map-left"></div>
        <div class="base-map-right"></div>
      </div>
      <div>
        <div class="header-main">
          <el-card class="box-card" v-for="(item, index) in examList" :key="index">
            <div slot="header" class="clearfix">
              <span>{{ item.title }}</span>
            </div>
            <div class="box-body">
              <div class="unit">评测单位</div>
              <p>
                ▶<span id="header-title">
                  上海现代服务业联合会互联网科创服务专业委员会</span>
              </p>
              <div class="unit">考试信息</div>
              <p v-if="item.title == '顺序练习'">▶不计时</p>
              <p v-else>
                ▶ 时长:
                {{ Math.floor((item.minutes / 60) * 10) / 10 }}小时
                (中途不可退出)
              </p>
              <p>▶ 题目: {{ item.num }}题 (单项选择、多项选择)</p>
              <el-divider></el-divider>
              <div class="flex-center">
                <button class="go-text" @click="examing(item.id, item.clist_id)">
                  {{ item.title == '顺序练习' ? '前往练习' : '前往考试' }}
                </button>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="body-main">
        <p id="body-title">友情提示 :</p>
        <p>(1) 考生需参加并完线上课程或线下课程后，才能参加考试 ;</p>
        <p>
          (2)
          考试前系统将对您的身份进行认证，信息一经认证后无法更改，考生的资料将对应证书的信息，请认直填写个人直实信息，以防出现身份错造成您的损失
          ;
        </p>
        <p>
          (3)
          智能监考平台在考试过程中会通过远程视频监控持续进行身份信息识别，请考生遵守考场纪律
          ;
        </p>
        <p>
          (4)
          考生考试期间请保持面部一直处于摄像头有效区域，如考试期间发现考生离开摄像头有效区域，则视为考生私自离开考场，本次考试无效
          ;
        </p>
        <p>
          (5)
          考生在参加评测期间应该遵守考试纪律，独立完成评测内容，考试时不得向他人交流，也不能通过搜索引整、书本等工具查阅相关内容
          ;
        </p>
        <p>
          (6) 违反考试规定者一经发现，则作废本次所有考试并视为本次所有考试无效。
        </p>
      </div>
    </div>
    <!-- <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="450px"
      v-loading="loading"
      center
      class="payStyle"
      :show-close='false'
    >
      <div class="top-box">
         <span>您还没有报名支付此课程,是否前往报名支付?</span>
         <div class="bot-box">
         <el-button type="primary" class="topay" @click="topay()">立刻前往报名</el-button>
         <el-button class="cancel" @click="cancel()">取消</el-button>
         </div>
      </div>
     
    </el-dialog> -->
    <el-dialog title="提示" :visible.sync="dialogVisiblet" width="450px" v-loading="loading" center class="payStyle"
      :show-close="false">
      <div class="top-box">
        <span>您还没有付费并完成课程学习,是否前往学习?</span>
        <div class="bot-box">
          <el-button type="primary" class="topay" @click="topay()">立刻前往学习</el-button>
          <el-button class="cancel" @click="dialogVisiblet = false">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  let _this
  export default {
    name: 'Examination1',
    data() {
      var validatePass2 = (rule, value, callback) => {
        if (value == '') {
          callback(new Error('请再次输入身份证号'))
        } else if (value !== this.form.idcard) {
          callback(new Error('两次输入不一致!'))
        } else {
          callback()
        }
      }
      return {
        rules: {
          name: {
            required: true,
            message: '请输入姓名',
            trigger: 'blur',
          },

          idcard: [
            {
              required: true,
              message: '请输入身份证号',
              trigger: 'blur',
            },
            {
              pattern: /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
              message: '请输入正确的身份证号',
              trigger: 'blur',
            },
          ],
          rIdcard: {
            required: true,
            validator: validatePass2,
            trigger: 'blur',
          },
        },
        payRadio: '1',
        toForm: {},
        cookieId: '',
        obj: {},
        form: {},
        redeemDialog: false,
        dialogVisible: false,
        dialogVisiblet: false,
        warningDialog: false,
        showInfo: false,
        radioOptions: [],
        examSelect: false,
        loading: false,
        redeemData: '',
        order_number: '',
        radio: '',
        appointmenttimes: [],
        attime: '',
        attimeShow: false,
        isappointment: false,
        user: {},
        examList: [],
        token: '',
        redeem_number: '',
        isSelect: '',
        repairDialog: false,
        examPassDialog: false,
        examNotPassDialog: false,
        isrepair: '',
        loading: true,
        examList: [
          {
            title: '顺序练习',
            minutes: 0,
            num: 409,
            id: 9320
          },
        ],
      }
    },
    created() {
      if (this.$store.state.wps_user.mobile) {
        _this = this
        this.form = {
          name: this.$store.state.wps_user.name,
          idcard: this.$store.state.wps_user.idcard,
        }
        this.obj = this.$store.state.wps_user
        _this.getExam()
      } else {
        this.$message.warning('您还未登录，请先登录！')
        this.$router.push('Login')
      }
    },
    methods: {
      getExam() {
        _this.loading = true
        _this.$http
          .get(process.env.VUE_APP_URL + 'paperShowList')
          .then(data => {
            if (data.data.code == 200) {
              _this.loading = false
              _this.examList = _this.examList.concat(data.data.data)
            } else {
              _this.$message.error(data.data.msg)
            }
          })
          .catch(err => {
            _this.$message.error('网络错误，请重试')
            console.log(err)
          })
      },

      examing(id, clist_id) {
        let _this = this
        // if (id == 9320) {
        //   window.location.href = 'http://ks.netclass.cn/entrance/' + id
        // }
        _this.clist_id = clist_id
        _this.$http
          .post(process.env.VUE_APP_URL + 'isPay', { id: id })
          .then(data => {
            if (data.data.code == 200) {
              if (id == 9320) {
                window.open(
                  'http://netban.cn/api/user/synwp/' + data.data.token + '?eid=' + id
                )
              } else {
                _this.$router.push({
                  name: 'examVerify',
                })
              }
            } else if (data.data.code == 201) {
              _this.dialogVisiblet = true
              return
            } else {
              _this.$message.error(data.data.msg)
            }
          })
      },
      topay() {
        this.$router.push({
          name: 'Course',
          params: { id: this.clist_id },
        })
      },
    },
  }
</script>

<style scoped>
  .all {
    width: 100%;
  }

  .header-main {
    width: 700px;
    /* height: 302px; */
    margin-top: -235px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 250px;
    flex-wrap: wrap;
  }

  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .flex {
    display: flex;
    width: 100%;
  }

  .flex-center {
    display: flex;
    justify-content: center;
  }

  .base-map-left {
    width: 50%;
    height: 350px;
    background-color: #fb5227;
    border-radius: 0 0 0 100%;
  }

  .base-map-right {
    width: 50%;
    height: 350px;
    background-color: #fb5227;
    border-radius: 0 0 100% 0;
  }

  .box-card {
    width: 280px;
    /* height: 300px; */
    border: none;
    margin-bottom: 30px;
  }

  /deep/.el-card__header {
    background-color: #fb5227;
    padding: 10px 20px;
    border-radius: 5px;
    border: 1px solid #ccc;
  }

  .clearfix {
    text-align: center;
    letter-spacing: 2px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    font-size: 18px;
  }

  /deep/.el-divider--horizontal {
    margin: 17px 0;
  }

  .box-body p {
    font-size: 12px;
    margin-left: 10px;
    margin-bottom: 13px;
    letter-spacing: 1px;
  }

  .unit {
    margin-bottom: 12px;
    width: 68px;
    height: 25px;
    font-family: Microsoft YaHei;
    font-weight: 500;
    background-color: #ece8e5;
    border-radius: 20%/0px 50% 50% 0px;
    text-align: left;
    padding-left: 10px;
    font-size: 14px;
    line-height: 25px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  #header-title {
    font-size: 14px;
    letter-spacing: 1px;
  }

  .go-text {
    width: 120px;
    height: 28px;
    line-height: 28px;
    border: 1px solid #fb5227;
    color: #fb5227;
    background-color: #ffffff;
    border-radius: 15px;
    font-size: 14px;
    cursor: pointer;
  }

  .body {
    width: 100%;
    display: flex;
    justify-content: center;
    height: 500px;
  }

  .body-main {
    width: 1280px;
    padding-top: 80px;
  }

  .body-main p {
    margin: 30px 0 30px 180px;
    font-weight: 400;
    font-size: 14px;
  }

  #body-title {
    font-size: 16px;
  }

  .top-box {
    text-align: center;
  }

  .bot-box {
    margin-top: 20px;
  }

  .top-box span {
    font-size: 16px;
    font-weight: 600;
  }

  .topay {
    margin-right: 110px;
  }
</style>